import styles from "./Header.module.css";

import logo from "../../../assets/images/logo/logo_delicices.png";

import SocialLinks from "../../common/SocialLinks/SocialLinks";

function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        {/* H1 único da aplicação */}
        <h1 className={styles.title}>
          <img
            className={styles.logo}
            src={logo}
            alt="Delicices"
          />
        </h1>

        <div className={styles.social}>
          <SocialLinks />
        </div>
      </div>
    </header>
  );
}

export default Header;